import moment from 'moment';

export default function (value) {
  if (value[value.length - 1].toLowerCase() !== 'z') value = `${value}Z`;

  moment.locale('pt-BR');
  return moment(new Date(value)).fromNow();
}
